import MapSearchResultItem from './MapSearchResultItem';

export default MapSearchResultItem;

export { MapSearchResultItem };
